import { render, staticRenderFns } from "./CaSnackbar.vue?vue&type=template&id=60cc946a"
import script from "./CaSnackbar.vue?vue&type=script&lang=js"
export * from "./CaSnackbar.vue?vue&type=script&lang=js"
import style0 from "./CaSnackbar.vue?vue&type=style&index=0&id=60cc946a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VSnackbar})
